<template>
  <div>
    <v-navigation-drawer fixed app v-model="nDrawer" color="primary">
      <v-toolbar flat>
        <v-list>
          <v-list-tile>
            <img src="static/bc.svg" height="30px"/>
            <v-list-tile-title class="title">
              &nbsp;&nbsp;Beyond Cloud
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-toolbar>

      <v-divider></v-divider>

      <v-list dense class="pt-0">
        <v-list-tile
          v-for="item in items"
          :key="item.title"
          :href="item.link"
          @click.stop="nDrawer = false"
        >
          <!-- <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action> -->

          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>      
    </v-navigation-drawer>
    <v-toolbar class="hidden-md-and-down" v-if="!toolbarShow" fixed v-scroll="onScroll" style="padding: 20px" color="transparent" flat scroll-off-screen scroll-target="#frontPage">
      <img src="static/badge.png" height="180px" style="margin-left: 50px;margin-top: 50px"/>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <template v-for="(item,index) in items">
          <v-btn :key="item.link" :href="item.link" class="buttonMenu" flat>{{item.title}}</v-btn>
          <v-icon v-if="index < (items.length - 1)" :key="item.link+1" x-large class="white--text text--lighten-2 rotate">remove</v-icon>
        </template>
      </v-toolbar-items>
    </v-toolbar>
    <v-toolbar class="hidden-md-and-down" small id="topbarfixed" v-else fixed v-scroll="onScroll">
      <img src="static/badge-blue.png" height="180px" style="margin-left: 50px;margin-top: 70px"/>
      <v-spacer></v-spacer>
      <v-toolbar-items>
          <template v-for="(item,index) in items">
            <v-btn :key="item.link" :href="item.link" class="buttonMenu" flat>{{item.title}}</v-btn>
            <v-icon v-if="index < (items.length - 1)" :key="item.link+1" x-large class="white--text text--lighten-2 rotate">remove</v-icon>
        </template>
        </v-toolbar-items>
    </v-toolbar>
    <v-toolbar class="hidden-lg-and-up" small color="transparent" flat absolute="">
      <v-btn color="white" class="hidden-lg-and-up" outline @click.stop="(nDrawer = !nDrawer)"> <v-icon>menu</v-icon></v-btn>                  
      <v-spacer></v-spacer>      
      <img src="static/badge.png" height="110px" style="margin-top: 50px"/>
    </v-toolbar>
  </div>
</template>
<script>

export default {
  name: 'app-toolbar',
  components: {    
  },
  data: () => ({
    nDrawer: false,
    offsetTop: 0,
    toolbarShow: false,
    items: [
      { title: 'Quem somos', link: '#quemsomos' },
      { title: 'Áreas de atuação', link: '#atuacao' },
      { title: 'Transformação Digital', link: '#transformacaodigital' },
      { title: 'Contato', link: '#contato' } 
    ]
  }),
  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    }
  },
  methods: {
    onScroll (e) {
      if (window.innerHeight >= this.offsetTop) {
        this.toolbarShow = false;        
      } else {
        this.toolbarShow = true;        
      }
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
    }    
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppToolbar.vue